import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=4b23958b&"
import script from "./CustomCard.vue?vue&type=script&lang=js&"
export * from "./CustomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports